import { BottomNavigationActionProps, Box, TabProps } from "@mui/material";
import { Message, HowToReg, ListAlt } from "@mui/icons-material";
import { PrpNavigation } from "@/components/PrpNavigation/PrpNavigation";
import { PrpNavigationItem } from "@/components/PrpNavigation";
import { PrpNavigationItemHome } from "@/components/PrpNavigation/PrpNavigationItemHome";
import { useAuthContext } from "@/context/AuthContext";

export const TaskerNavigation = () => {
  const { user } = useAuthContext();

  return (
    <Box
      sx={{
        "& .MuiTabs-flexContainer": {
          width: "100vw",
        },
        "& .MuiTab-root": {
          flexGrow: 0,
          flexBasis: "105px",
        },
      }}
    >
      <PrpNavigation>
        <PrpNavigationItemHome data-cypress="nav-tasker-home" />
        <PrpNavigationItem
          item={{
            position: 1,
            path: "/sendit",
            label: "My Messages",
            icon: <Message />,
            isSelectedCheck: (location) => location.pathname === "/sendit",
          }}
          tabProps={
            {
              sx: {
                minHeight: "85px",
                marginLeft: "calc(50% - 350px)",
                maxWidth: "180px",
              },
              "data-cypress": "nav-tasker-messages",
            } as TabProps
          }
          bottomNavigationActionProps={
            {
              "data-cypress": "nav-tasker-messages",
            } as BottomNavigationActionProps
          }
        />
        <PrpNavigationItem
          item={{
            position: 2,
            path: "/sendit/programs",
            label: "Programs",
            icon: <ListAlt />,
          }}
          tabProps={
            {
              sx: {
                minHeight: "85px",
                maxWidth: "180px",
              },
              "data-cypress": "nav-tasker-programs",
            } as TabProps
          }
          bottomNavigationActionProps={
            {
              sx: {
                "& .MuiBottomNavigationAction-label": {
                  lineHeight: "1.1",
                },
              },
              "data-cypress": "nav-tasker-programs",
            } as BottomNavigationActionProps
          }
        />
        {user?.role === "manager" && (
          <PrpNavigationItem
            item={{
              position: 3,
              path: "/sendit/approve-messages",
              label: "Approve Messages",
              icon: <HowToReg />,
            }}
            tabProps={
              {
                sx: {
                  minHeight: "85px",
                  maxWidth: "180px",
                },
                "data-cypress": "nav-tasker-approve-messages",
              } as TabProps
            }
            bottomNavigationActionProps={
              {
                "data-cypress": "nav-tasker-approve-messages",
              } as BottomNavigationActionProps
            }
          />
        )}
      </PrpNavigation>
    </Box>
  );
};
